import { useState } from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../contexts/LocaleContext";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function MobileMenu({ open, onClose }: Props) {
  const { t } = useLocale();
  const [subOpen, setSubOpen] = useState(false);

  return (
    <div
      className="mobile-menu"
      id="mobileMenu"
      style={{ display: open ? "block" : "none" }}
    >
      <div className="mobile-menu-header">
        <span className="mobile-menu-title">{t("footer.logoAlt")}</span>
        <button
          type="button"
          className="close-icon"
          onClick={onClose}
          aria-label="Menü schließen"
        >
          <i className="fas fa-times" />
        </button>
      </div>

      <div className="mobile-menu-content">
        <nav className="mobile-nav">
          <Link to="/mission" onClick={onClose}>
            {t("nav.mission")}
          </Link>
          <Link to="/video" onClick={onClose}>
            {t("nav.howItWorks")}
          </Link>
          <Link to="/art" onClick={onClose}>
            {t("nav.galleryMobile")}
          </Link>

          <div className="mobile-submenu">
            <button type="button" onClick={() => setSubOpen((v) => !v)}>
              {t("nav.socialEngagement")}
              <i
                className={`fas fa-chevron-${subOpen ? "up" : "down"}`}
                aria-hidden="true"
              />
            </button>
            <div
              className="submenu-links"
              style={{ display: subOpen ? "block" : "none" }}
            >
              <a
                href="https://elke-schark-foundation.com"
                target="_blank"
                rel="noreferrer"
                onClick={onClose}
              >
                {t("nav.elkeFoundation")}
              </a>
            </div>
          </div>

          <Link to="/world" onClick={onClose}>
            {t("nav.discoverArt")}
          </Link>
          <Link to="/world" onClick={onClose}>
            {t("nav.buyFramesShort")}
          </Link>

          <div className="mobile-menu-separator" />

          <Link to="/contact" onClick={onClose}>
            {t("topbar.contact")}
          </Link>
        </nav>
      </div>
    </div>
  );
}
